import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CardBaseComponent } from '../card-base/card-base.component';
import { CardModel } from '../models/card.model';

@Component({
  selector: 'mb-card-column',
  templateUrl: './card-column.component.html',
  styleUrls: ['./card-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CardBaseComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardColumnComponent {
  @Input() alignContent!: string;
  @Input() data!: CardModel;
  @Input() fuelLabelPosition = 'default';
}
